// Sales Type action constants
export const LIBRARY_SALES_TYPE_PAGE_REQUEST =
  'LIBRARY_SALES_TYPE_PAGE_REQUEST';

export const LIBRARY_SALES_TYPE_SET_LIST_SALES =
  'LIBRARY_SALES_TYPE_SET_LIST_SALES';

export const LIBRARY_SALES_TYPE_SET_OUTLETS = 'LIBRARY_SALES_TYPE_SET_OUTLETS';

export const LIBRARY_SALES_TYPE_SET_SALES_DETAIL =
  'LIBRARY_SALES_TYPE_SET_SALES_DETAIL';

export const LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN =
  'LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN';

export const LIBRARY_SALES_TYPE_SET_TOTAL_PAGE =
  'LIBRARY_SALES_TYPE_SET_TOTAL_PAGE';

export const LIBRARY_SALES_TYPE_SET_CURRENT_PAGE =
  'LIBRARY_SALES_TYPE_SET_CURRENT_PAGE';

export const LIBRARY_SALES_TYPE_ON_CLICK_ROW =
  'LIBRARY_SALES_TYPE_ON_CLICK_ROW';

export const LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN =
  'LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN';

export const LIBRARY_SALES_TYPE_SET_GRATUITY =
  'LIBRARY_SALES_TYPE_SET_GRATUITY';

export const LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP =
  'LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP';

export const LIBRARY_SALES_TYPE_ON_CLICK_CANCEL =
  'LIBRARY_SALES_TYPE_ON_CLICK_CANCEL';

export const LIBRARY_SALES_TYPE_DELETE_SALES_REQUEST =
  'LIBRARY_SALES_TYPE_DELETE_SALES_REQUEST';

export const LIBRARY_SALES_TYPE_DELETE_SALES =
  'LIBRARY_SALES_TYPE_DELETE_SALES';

export const LIBRARY_SALES_TYPE_SET_DELETED_SALES =
  'LIBRARY_SALES_TYPE_SET_DELETED_SALES';

export const LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL =
  'LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL';

export const LIBRARY_SALES_TYPE_CANCEL_DELETE =
  'LIBRARY_SALES_TYPE_CANCEL_DELETE';

export const LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL =
  'LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL';

export const LIBRARY_SALES_TYPE_ACTIVATED_SALES_REQUEST =
  'LIBRARY_SALES_TYPE_ACTIVATED_SALES_REQUEST';

export const LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES =
  'LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES';

export const LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL =
  'LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL';

export const LIBRARY_SALES_TYPE_ACTIVATED_SALES =
  'LIBRARY_SALES_TYPE_ACTIVATED_SALES';

export const LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL =
  'LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL';

export const LIBRARY_SALES_TYPE_CANCEL_ACTIVATED =
  'LIBRARY_SALES_TYPE_CANCEL_ACTIVATED';

export const LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY =
  'LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY';

export const LIBRARY_SALES_TYPE_ON_CHANGE_OUTLET_IDS =
  'LIBRARY_SALES_TYPE_ON_CHANGE_OUTLET_IDS';

export const LIBRARY_SALES_TYPE_ON_CLICK_CREATE_SALES =
  'LIBRARY_SALES_TYPE_ON_CLICK_CREATE_SALES';

export const LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE =
  'LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE';

export const LIBRARY_SALES_TYPE_SUBMIT_FORM_UPDATE =
  'LIBRARY_SALES_TYPE_SUBMIT_FORM_UPDATE';

export const LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM =
  'LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM';

export const LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL =
  'LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL';

export const LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL =
  'LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL';

export const LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE_ALL_OUTLETS =
  'LIBRARY_SALES_TYPE_SUBMIT_FORM_CREATE_ALL_OUTLETS';

export const LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL =
  'LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL';

export const LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS =
  'LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS';

export const LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL =
  'LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL';

export const LIBRARY_SALES_TYPE_LIST_REQUEST =
  'LIBRARY_SALES_TYPE_LIST_REQUEST';

export const LIBRARY_SALES_TYPE_CHECK_DELETABLE =
  'LIBRARY_SALES_TYPE_CHECK_DELETABLE';

export const LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL =
  'LIBRARY_SALES_TYPE_SHOW_CHECK_DELETABLE_MODAL';

export const LIBRARY_SALES_TYPE_SET_SALES_TYPE_RESERVED =
  'LIBRARY_SALES_TYPE_SET_SALES_TYPE_RESERVED';

export const LIBRARY_SALES_TYPE_RESERVED_FIND_BY_NAME =
  'LIBRARY_SALES_TYPE_RESERVED_FIND_BY_NAME';
